import { appRoutes } from "../../../constants/appRoutes";

export const memberDetailRoute = {
    path: appRoutes.memberDetail.path,
    lazy: () => import("../../../pages/MemberDetail"),
}